import { ActionKeys } from '~/actions/constants';
import PaymentMethods, { PaymentMethodType } from '~/types/PaymentMethods';

export function openCreditCardModal() {
  return <const>{
    type: ActionKeys.BILLING_OPEN_CREDIT_CARD_MODAL,
  };
}

export function closeCreditCardModal() {
  return <const>{
    type: ActionKeys.BILLING_CLOSE_CREDIT_CARD_MODAL,
  };
}

export function fetchPaymentMethods() {
  return <const>{
    type: ActionKeys.FETCH_PAYMENT_METHODS,
  };
}

export function fetchPaymentMethodsSuccess(payload: PaymentMethods) {
  return <const>{
    payload,
    type: ActionKeys.FETCH_PAYMENT_METHODS_SUCCESS,
  };
}

export function fetchPaymentMethodsError() {
  return <const>{
    type: ActionKeys.FETCH_PAYMENT_METHODS_ERROR,
  };
}

export function changePaymentMethod() {
  return <const>{
    type: ActionKeys.PAYMENT_METHOD_CHANGE,
  };
}

export function changePaymentMethodSuccess() {
  return <const>{
    type: ActionKeys.PAYMENT_METHOD_CHANGE_SUCCESS,
  };
}

export function changePaymentMethodError() {
  return <const>{
    type: ActionKeys.PAYMENT_METHOD_CHANGE_ERROR,
  };
}

export function openChangePaymentModal(paymentType: PaymentMethodType) {
  return <const>{
    paymentType,
    type: ActionKeys.BILLING_OPEN_CHANGE_PAYMENT_MODAL,
  };
}

export function closeChangePaymentModal() {
  return <const>{
    type: ActionKeys.BILLING_CLOSE_CHANGE_PAYMENT_MODAL,
  };
}

export function showCCUpdatedNotification() {
  return <const>{
    type: ActionKeys.BILLING_CC_UPDATED_NOTIFICATION_SUCCESS,
  };
}

export function hideCCUpdatedNotification() {
  return <const>{
    type: ActionKeys.BILLING_CC_UPDATED_NOTIFICATION_HIDE,
  };
}

export function showChangePaymentNotificationSuccess() {
  return <const>{
    type: ActionKeys.BILLING_CHANGE_PAYMENT_NOTIFICATION_SUCCESS,
  };
}

export function showChangePaymentNotificationError() {
  return <const>{
    type: ActionKeys.BILLING_CHANGE_PAYMENT_NOTIFICATION_ERROR,
  };
}

export function hideChangePaymentNotification() {
  return <const>{
    type: ActionKeys.BILLING_CHANGE_PAYMENT_NOTIFICATION_HIDE,
  };
}

export function setPaymentProcessingError(paymentProcessingErrorMessage: string) {
  return <const>{
    type: ActionKeys.BILLING_SET_PAYMENT_PROCESSING_ERROR,
    paymentProcessingError: paymentProcessingErrorMessage,
  };
}

export function clearPaymentProcessingError() {
  return <const>{
    type: ActionKeys.BILLING_CLEAR_PAYMENT_PROCESSING_ERROR,
  };
}

export type BillingActions =
  | ReturnType<typeof openCreditCardModal>
  | ReturnType<typeof closeCreditCardModal>
  | ReturnType<typeof fetchPaymentMethods>
  | ReturnType<typeof fetchPaymentMethodsSuccess>
  | ReturnType<typeof fetchPaymentMethodsError>
  | ReturnType<typeof changePaymentMethod>
  | ReturnType<typeof changePaymentMethodSuccess>
  | ReturnType<typeof changePaymentMethodError>
  | ReturnType<typeof openChangePaymentModal>
  | ReturnType<typeof closeChangePaymentModal>
  | ReturnType<typeof showCCUpdatedNotification>
  | ReturnType<typeof hideCCUpdatedNotification>
  | ReturnType<typeof showChangePaymentNotificationSuccess>
  | ReturnType<typeof showChangePaymentNotificationError>
  | ReturnType<typeof hideChangePaymentNotification>
  | ReturnType<typeof setPaymentProcessingError>
  | ReturnType<typeof clearPaymentProcessingError>;
